export interface SelectSearchConfig {
  /** whether multiple options can be selected or not */
  multiple?: boolean;
  /** whether to enable the search */
  search?: boolean;
  //** Only for tag fields */
  tagField?: boolean;
  /** mat form field label */
  label?: string;
  /** if form field is required */
  required?: boolean;
  /** if form field is required */
  minlength?: number;
  minlengthError?: boolean;
  /** form field is required text */
  requiredText?: string;
  /** form field is minlength text */
  minLengthText?: string;
  /** if option list is in titlecase */
  titleCase?: boolean;
  /** inline image along with mat option list */
  inlineImage?: boolean;
  /** disableSingleSelect is used to disable automatically select option when we have only one dropdown option */
  disableSingleSelect?: boolean;
  disableStringTypeOptions?: string[];
  /** enable mat group option */
  enableMatOptGroup?: boolean;
  /** enable 2nd part of label */
  enableSecondPartLabel?: boolean;
  /** By default all data source are sorted. Set it 'false' if don't want to sort
  // If you set a value to sortDataSource, always keep the sequence of config input in the
  // parent component above the data source input */
  sortDataSource?: boolean;
  /** enable mat-divide and position it in mat-select */
  matDivider?: number;
}
